import { createFileRoute, Link } from '@tanstack/react-router';
import { ActionButton } from '@/components/ui+/ActionButton';
import { WorkflowTable } from '@/components/WorkflowTable';

export const Route = createFileRoute('/a/workflows/$workflowId')({
  component: Component,
});

function Component() {
  const { workflowId } = Route.useParams();

  return (
    <div>
      <div className="mb-4">
        <ActionButton variant="outline" size="sm">
          <Link to="/a/workflows">Back to workflows</Link>
        </ActionButton>
      </div>

      <div className="mt-6">
        <WorkflowTable workflowId={workflowId} />
      </div>
    </div>
  );
}
